import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';

@Injectable({
  providedIn: 'root'
})
export class FilterSharingService {
  private filtersSubject = new BehaviorSubject<CompositeFilterDescriptor>({ logic: 'and', filters: [] });
  filters$ = this.filtersSubject.asObservable();

  setFilters(filters: CompositeFilterDescriptor): void {
    this.filtersSubject.next(filters);
  }
}
